import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: window._env_.MEDUSA_URL,
  }),
  endpoints: (builder) => ({
    createMedusaEventBatch: builder.mutation({
      query: ({ payload, event_name }) => {
        const url = new URL('/batch/preview-stream', window._env_.MEDUSA_URL)

        if (event_name) {
          url.searchParams.append('event_name', event_name)
        }
        return {
          url: url.toString(),
          method: 'POST',
          body: payload,
        }
      },
    }),

    createMedusaBatchAvro: builder.mutation({
      query: ({ payload, event_name }) => {
        const url = new URL('/schema/avro/stream', window._env_.MEDUSA_URL)
        if (event_name) {
          url.searchParams.append('event_name', event_name)
        }
        return {
          url: url.toString(),
          method: 'POST',
          body: payload,
        }
      },
    }),

    getMedusaGenerators: builder.query({
      query: () => {
        return {
          url: `/generators`,
          method: 'GET',
        }
      },
    }),

    getMedusaGeneratorCategories: builder.query({
      query: () => {
        return {
          url: `/generators/categories`,
          method: 'GET',
        }
      },
    }),

    getMedusaGeneratorCategory: builder.query({
      query: (category) => {
        return {
          url: `/generators/categories/${category}`,
          method: 'GET',
        }
      },
    }),

    getMedusaExampleDatasets: builder.query({
      query: () => {
        return {
          url: `/examples/streaming-datasets`,
          method: 'GET',
        }
      },
    }),
  }),
})

export const {
  useCreateMedusaEventBatchMutation,
  useCreateMedusaBatchAvroMutation,
  useGetMedusaGeneratorsQuery,
  useGetMedusaGeneratorCategoriesQuery,
  useGetMedusaGeneratorCategoryQuery,
  useGetMedusaExampleDatasetsQuery,
} = api
